import { all, put, select, takeEvery } from "redux-saga/effects";
import { POST_LOGIN } from "./actionsType";
import { ERROR, LOADING, LOADING_BLOCKING, SUCCEDED } from "../../global/statusLabels";
import { getProfiloAriannaApiSPID, getProfiloAriannaApiTS } from "../../api/apiFunctionsScreening";
import { resetMessaggioStateAction, setMessaggioAction } from "../messaggio/actions";
import { ERRORE_ASR, ERRORE_DATI_ERRATI, ERRORE_GENERICO_API, ERRORE_GENERICO_POSTLOGIN, ERRORE_PAZIENTE_NON_TROVATO, ERRORE_SESSION_EXPIRED } from "../../global/messaggioLabels";
import { getProfiloAriannaActionSuccess } from "../screening/actions";
import { campagnaSelector } from "../persistentStore/selectors";
import { ESITI, ROOT, SCREENINGCOLONRETTO } from "../../global/urlMapping";
import { crypt, EXPIRATION_TIME } from "../../auth/authFunctions";
import { isAuthenticatedActionSuccess } from "../auth/actions";
import { CFTNS } from "../auth/actionsType";
import { ricercaComuniActionSuccess, ricercaIscrizioneActionSuccess } from "../anagrafe/actions";
import { ricercaComuniApiSPID, ricercaComuniApiTS, ricercaIscrizioneApiSPID, ricercaIscrizioneApiTS } from "../../api/apiFunctionsAnagrafe";
import { postLoginActionSuccess } from "./actions";
import { generaLog } from "../../functions/utils";
import { PATIENT_NOT_FOUND_IN_AGE_RANGE, PATIENT_NOT_FOUND_OUT_AGE_RANGE } from "../../global/messaggiErrore";


function* postLoginWorker() {
    yield put(setMessaggioAction({ status: LOADING_BLOCKING }))
    yield put(postLoginActionSuccess({ value: false, status: LOADING }))
    generaLog("postLoginWorker", "log")

    const campagna = yield select(campagnaSelector)



    let responseGetProfiloArianna;

    let responseRicercaComuni;
    let responseRicercaIscrizione;



    //chiamo anagrafe e getprofiloarianna
    yield put(ricercaIscrizioneActionSuccess({ value: undefined, status: LOADING }))
    yield put(getProfiloAriannaActionSuccess({ value: undefined, status: LOADING }))
    try {
        if (sessionStorage.tempCFTNS || sessionStorage.CFTNS) {
            responseRicercaIscrizione = yield ricercaIscrizioneApiTS()
        } else {
            responseRicercaIscrizione = yield ricercaIscrizioneApiSPID()
        }
    } catch (error) {//anagrafe è andata in errore
        yield put(ricercaIscrizioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else if (error?.response?.status === 404) {
            // errore ASL: paziente non iscritto oppure non presente in una delle ASL abilitate al servizio di screening
            yield put(setMessaggioAction({ status: ERRORE_ASR }))
        } else if (error?.response?.status === 401) {
            // dati errati
            yield put(setMessaggioAction({ status: ERRORE_DATI_ERRATI }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_POSTLOGIN }))
        }

    }

    //anagrafe è andata a buon fine 
    if (responseRicercaIscrizione?.status === 200) {
        yield put(ricercaIscrizioneActionSuccess({ value: responseRicercaIscrizione.data, status: responseRicercaIscrizione?.status }))
        // cerco nuovo campo CodiceAreaAssistenza: se null, recupero campo CodiceAslAssistenza
        const aslAssistito = responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAreaAssistenza ?? responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAslAssistenza
        sessionStorage.setItem("ASL", crypt(aslAssistito));

        //chiamo getprofiloarianna
        try {
            if (sessionStorage.tempCFTNS || sessionStorage.CFTNS) {
                responseGetProfiloArianna = yield getProfiloAriannaApiTS()
            } else {
                responseGetProfiloArianna = yield getProfiloAriannaApiSPID()
            }
        } catch (error) {//getProfiloArianna è andata in errore
            yield put(getProfiloAriannaActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
            yield put(postLoginActionSuccess({ value: false, status: ERROR }))
            if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
            } else if (error?.response?.status === 404) {
                // assistito non presente nella banca dati del Servizio di Prevenzione

                // controllo se eta sia nel range 50-74
                const codFisc = responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceFiscale;
                const dataNascita = codFisc.substring(6, 8); // estraggo anno di nascita
                const date = new Date().getFullYear(); // anno corrente
                // calcolo l'intervallo di anni di nascita per cui un utente può eseguire lo screening
                const lowerDate = (date - 75).toString().substring(2)
                const upperDate = (date - 49).toString().substring(2)
                let titoloMessaggio = "";
                if (dataNascita >= lowerDate && dataNascita <= upperDate) {
                    // eta OK
                    titoloMessaggio = PATIENT_NOT_FOUND_IN_AGE_RANGE
                } else {
                    // eta fuori range
                    titoloMessaggio = PATIENT_NOT_FOUND_OUT_AGE_RANGE
                }
                yield put(setMessaggioAction({ status: ERRORE_PAZIENTE_NON_TROVATO, value: { titolo: titoloMessaggio } }))
            } else {
                yield put(setMessaggioAction({ status: ERRORE_GENERICO_POSTLOGIN }))
            }

        }
    }

    if (responseGetProfiloArianna?.status === 200 && responseGetProfiloArianna?.data?.patient !== null) {
        yield put(getProfiloAriannaActionSuccess({ value: responseGetProfiloArianna?.data, status: responseGetProfiloArianna?.status }))
        //CFTNS -> è la sua login
        if (sessionStorage.tempCFTNS) {
            sessionStorage.setItem("CFTNS", sessionStorage.tempCFTNS)
            sessionStorage.setItem("expirationDate", new Date().getTime() + EXPIRATION_TIME)
            sessionStorage.removeItem("tempCFTNS")
            yield put(isAuthenticatedActionSuccess({ isAuthenticated: true, authType: CFTNS }))
        }


        //chiamo la ricerca comuni
        try {
            if (sessionStorage.CFTNS) {
                responseRicercaComuni = yield ricercaComuniApiTS(responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAreaAssistenza ?? responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAslAssistenza)
            } else {
                responseRicercaComuni = yield ricercaComuniApiSPID(responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAreaAssistenza ?? responseRicercaIscrizione.data?.DatiMinimiIscrizione?.CodiceAslAssistenza)
            }
        } catch (error) {//errore ricerca comuni
            if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
            } else {
                yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
            }
            yield put(ricercaComuniActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        }
        //ricerca comuni è andata a buon fine
        if (responseRicercaComuni?.status === 200) {
            // aggiungiamo valore nullo all'array Comuni
            const array = responseRicercaComuni?.data;
            array.Comuni.push({ NomeComune: '--', CodIstat: '00', Distretto: 0 })
            yield put(ricercaComuniActionSuccess({ value: array, status: responseRicercaComuni?.status }))
        }

        //GESTIONE INFORMATIVA NON PIU NECESSARIA
        /* 
        //guardo se ha preso visione dell'informativa
        yield put(getPresaVisioneActionSuccess({ value: undefined, status: LOADING }))
        try {
            if (sessionStorage.CFTNS) {
                responseGetPresaVisione = yield getPresaVisioneApiTS()
            } else {
                responseGetPresaVisione = yield getPresaVisioneSPID()
            }

        } catch (error) {//getPresaVisione è andata in errore
            yield put(postLoginActionSuccess({ value: true, status: SUCCEDED }))
            yield put(getPresaVisioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
            if (error?.response?.status === 404 || error?.response?.status === 400) {
                generaLog("No preso visione - profilo non presente", "log")
                yield put(resetMessaggioStateAction())
                window.location.href = PRIVACY
            } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
            }
            else {
                yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
            }
        }
        if (responseGetPresaVisione?.status === 204) {
            yield put(postLoginActionSuccess({ value: true, status: SUCCEDED }))
            yield put(getPresaVisioneActionSuccess({ value: responseGetPresaVisione?.data, status: responseGetPresaVisione?.status }))
            generaLog("No preso visione - profilo presente", "log")
            yield put(resetMessaggioStateAction())
            window.location.href = PRIVACY
        }
        else if (responseGetPresaVisione?.status === 200) { //getPresaVisione è andata a buon fine 
            yield put(postLoginActionSuccess({ value: true, status: SUCCEDED }))
            yield put(getPresaVisioneActionSuccess({ value: responseGetPresaVisione?.data, status: responseGetPresaVisione?.status }))
            generaLog("Presa visione", "log")
            //faccio la patch del profilo
            const profilo = {
                'codiceFiscale': responseGetProfiloArianna?.data?.patient?.fiscalCode,
                'nome': responseGetProfiloArianna?.data?.patient?.patientGivenName,
                'cognome': responseGetProfiloArianna?.data?.patient?.patientFamilyName,
                'contatti': {
                    "email": responseGetProfiloArianna?.data?.patient?.personalEmail,
                    "telefono": responseGetProfiloArianna?.data?.patient?.personalMobile,
                    'indirizzo': responseGetProfiloArianna?.data?.patient?.residenceAddress + " " + responseGetProfiloArianna?.data?.patient?.residenceZipCode + " " + responseGetProfiloArianna?.data?.patient?.residenceMunicipalityCode
                }
            }
            try {
                if (sessionStorage.CFTNS) {
                    yield patchProfiloApiTS(profilo)
                } else {
                    yield patchProfiloApiSPID(profilo)
                }
            } catch (error) {//errore nella patch profilo
                if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                    yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
                }
            }
            //rimando alla pagina di screening cliccata
            yield put(resetMessaggioStateAction())

            if (campagna === 'CL') {
                generaLog(campagna, "log")
                window.location.href = SCREENINGCOLONRETTO
            }
            else if (campagna === 'ESITI') {
                window.location.href = ESITI
            }
            else {
                window.location.href = ROOT
            }
        }
            */
        //rimando alla pagina di screening cliccata
        yield put(postLoginActionSuccess({ value: true, status: SUCCEDED }))
        yield put(resetMessaggioStateAction())


        if (campagna === 'CL') {
            generaLog(campagna, "log")
            window.location.href = SCREENINGCOLONRETTO
        }
        else if (campagna === 'ESITI') {
            window.location.href = ESITI
        }
        else {
            window.location.href = ROOT
        }
    }
    else {
        yield put(postLoginActionSuccess({ value: false, status: ERROR }))

    }


}

function* postLoginWatcher() {
    yield takeEvery(POST_LOGIN, postLoginWorker)
}

export function* postloginWatchers() {
    yield all([
        postLoginWatcher(),

    ]);
}
